import { create } from "zustand";

/**
 * Whether DashboardDarkTheme is on for the signed-in user: null until flags
 * load. DarkThemeFlagGate writes it from inside the authed tree; _app reads
 * it to force Light on ThemeProvider, which sits above the flag context.
 * In memory only, so the viewer's stored theme survives the flag being off
 * (another org, impersonation).
 */
type DarkThemeAllowedState = {
  allowed: boolean | null;
  setAllowed: (allowed: boolean | null) => void;
};

const useDarkThemeAllowedStore = create<DarkThemeAllowedState>((set) => ({
  allowed: null,
  setAllowed: (allowed) => set({ allowed }),
}));

export default useDarkThemeAllowedStore;
